module.exports = __webpack_public_path__ + "static/img/codeTraceability.a6565f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/codeTraceability.jpg
// module id = GqgY
// module chunks = 0